export interface RegistratieSuccesvol {
  event: 'registratie_succesvol';
}

export interface Heartbeat {
  event: 'heartbeat';
}

export interface ReceivedTimestamp {
  timestamp: Date;
}

export type WerklijnUpdateStatus = 'TOEGEVOEGD' | 'VERWIJDERD' | 'BIJGEWERKT';
export type InregelingUpdateStatus = 'VERWIJDERD_INREGELING' | 'BIJGEWERKT_INREGELING';
export type ConflictenBron = 'INTERN' | 'EXTERN' | 'ACCEPTEREN';

export const DefectUpdateStatus = 'DEFECT_BIJGEWERKT';
export const UitvoeringsmeldingUpdateStatus = 'UITVOERINGSMELDING_BIJGEWERKT';
export const ConflictUpdateStatus = 'CONFLICT_BIJGEWERKT';

export interface WerklijnUpdate {
  event: 'werklijn_update';
  werklijnId: string;
  versie: number;
  status: WerklijnUpdateStatus;
}

export interface InregelingUpdate {
  event: 'inregling_update';
  werklijnIdBijInregeling: string;
  status: InregelingUpdateStatus;
}

export interface DefectUpdate {
  event: 'defect';
  defectId: string;
  werklijnId: string;
  eenheidNummer: string;
  status: typeof DefectUpdateStatus;
}

export interface UitvoeringsmeldingUpdate {
  event: 'uitvoeringsmelding';
  werklijnId: string;
  treinnummer: number;
  treindatum: string;
  status: typeof UitvoeringsmeldingUpdateStatus;
}

export interface ConflictUpdate {
  event: 'conflict';
  werklijnId: string;
  bron: ConflictenBron;
  status: typeof ConflictUpdateStatus;
}

export type TimestampedWerklijnUpdate = (
  WerklijnUpdate | InregelingUpdate | DefectUpdate | UitvoeringsmeldingUpdate | ConflictUpdate
) &
  ReceivedTimestamp;

export type BamServerSentEvent = RegistratieSuccesvol | Heartbeat | WerklijnUpdate;
